import {Button, Space} from "antd";
import {SearchConfiguration} from "../../interfaces/OrgDetail.interface";

export interface HitInterface {
    id: number,
    siteId: number,
    type: "TV" | "MOVIE" | "SEASON" | "SERIES",
    programmeId: string,
    showId: string,
    showTitle: string,
    title: string,
    seasonNumber: number,
    episodeNumber: number
}

export function buildHitTitle(hit: HitInterface) {
    switch (hit.type) {
        case "TV": return `${hit.showTitle} (S${hit.seasonNumber}E${hit.episodeNumber})`
        default: return hit.title ?? hit.showTitle
    }
}

export function buildHitDeeplinkPath(hit: HitInterface) {
    switch (hit.type) {
        case "SERIES": return `/#/shows/${hit.programmeId}`
        case "SEASON": return `/#/shows/${hit.showId}/season/${hit.seasonNumber}`
        case "TV": return `/#/shows/${hit.showId}/seasons/${hit.seasonNumber}/episode/${hit.programmeId}`
        case "MOVIE": return `/#/movie/${hit.programmeId}`
    }
}

interface CustomHitProps {
    hit: HitInterface,
    onSelected: (hit: HitInterface, deeplink: string, imageUrl: string) => void,
    searchConfig: SearchConfiguration
}

export const CustomHit = ({ hit, onSelected, searchConfig }: CustomHitProps) => {
    const headend = searchConfig?.headendBaseUrl;
    const imageUrl = `${headend}/imageHelper.php?id=${hit.id}:${hit.siteId}:STILL:LANDSCAPE&w=410&appID=TONTON`
    const imagePreview = `${headend}/imageHelper.php?id=${hit.id}:${hit.siteId}:STILL:LANDSCAPE&w=125&appID=TONTON`
    const deeplink = searchConfig?.deeplinkBaseUrl + buildHitDeeplinkPath(hit)

    return <Space align='start' key={hit.id}>
        <img src={imagePreview} alt={hit.title} height={75}/>

        <Space size={2} direction='vertical'>
            <b>{buildHitTitle(hit)}</b>
            <span>Deeplink: <a href={deeplink} target='_blank'>{deeplink}</a></span>
            <Button type='primary' onClick={() => onSelected(hit, deeplink, imageUrl)}>Use</Button>
        </Space>
    </Space>
};